import * as React from 'react'

import {ImageSkuBlock} from "@components";


export default function imageSkuColumn() {
    return {
        name: 'skuID', label: 'Product Image',
        options: {
            filter: false,
			headerAlign: 'left',
            setCellProps: () => ({ sx: {
				justifyContent: 'center'
			}}),
            customBodyRowRenderLite: (value, { thumbnail, skuName }) => <ImageSkuBlock 
                skuID={value} 
                imageURL={thumbnail}
                skuName={skuName}
                contentProps={{
                    sx: { margin: '0' }
                }}
            />
        }
    }
}